import axios from "axios";
import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

  export const createUser = async (data) => {
      try {
        const response = await axios.post(`/auth/register`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getUsers = async () => {
      try {
        const response = await api.get("users/all");
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getUserById = async (id) => {
      try {
        const response = await api.get(`/users/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getUserByEmail = async (email) => {
      try {
        const response = await api.get(`/users/email/${email}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateUser = async ( id, data) => {
      try {
        const response = await api.put(`users/update/${id}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteUser = async (id) => {
    try {
        const response = await api.delete('users/delete/'+id);
        return response;
    } catch (error) {
        throw error;
    }
  };

  export const getRole = async () => {
    try {
        const response = await api.get('roles/all');
        return response;
    } catch (error) {
        throw error;
    }
  };

  export const getHistoryUser = async (userId) => {
    try {
      const response = await api.get(`/history/users/${userId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
